import { useFetch } from "../../../common/hooks/useFetch.js";
import { getDataVehicleInspectionService } from "../services/getDataVehicleInspection.service.js";
import XLSX from "sheetjs-style";
import { saveFile } from "../../../common/utils/saveFile.util.js";
import moment from "moment";
import Swal from "sweetalert2";
export const useGetDataVehicleInspectionQuery = () => {
  const fetchData = useFetch();
  const exportVehiclesInspected = async ({ filters }) => {
    try {
      if (!filters.initialDate || !filters.finalDate) {
        Swal.fire({
          icon: "warning",
          title: "Fechas requeridas",
          text: "Por favor, seleccione las fechas inicial y final.",
        });
        return;
      }
      const response = await getDataVehicleInspectionService(fetchData)({
        filters,
      });
      if (response.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "No hay datos para exportar",
          text: "No se encontraron datos para los filtros seleccionados.",
        });
      }

      const dataToExport = response.map((item) => {
        const keyPlate = Object.keys(item).find((key) => key.includes("placa"));
        return {
          FECHA: item.Fecha_registro,
          PLACA: item[keyPlate],
          CONDUCTOR: item.Kilometraje,
          IDENTIFICACION: item.identificacion,
          "PERSONA VERIFICO": item.usuarioaprobo,
          APROBO: item.Estado === "Aprobado" ? "SI" : "NO",
        };
      });
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

      const ws = XLSX.utils.json_to_sheet(dataToExport);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, { booktype: "xlsx", type: "array" });
      const file = new Blob([excelBuffer], { type: fileType });
      const filename = `Inspeccion-vehiculos-${moment().format(
        "DD-MM-YYYY",
      )}_${moment().unix()}.xlsx`;
      saveFile(file, filename);
    } catch (error) {}
  };

  return {
    exportVehiclesInspected,
  };
};
